/**
 * Copyright 2015-present Isshoikka. All Rights Reserved.
 *
 */

const IsshoikkaArrangementNavigationActionConstants = {
    MOVE_PREVIOUS: "move_previous",
    MOVE_NEXT: "move_next",
    MOVE_FIRST: "move_first",
    MOVE_LAST: "move_last",
};

export default IsshoikkaArrangementNavigationActionConstants;
